<template>
  <div class="rd-page" :class="{ 'over': flagxz || flaglc === true }" id="printContent">
    <rd-header v-show="!loginHeader && !noHeaderFooter" :userInfo="user" @cityChange="cityChange"></rd-header>
    <login-header v-show="loginHeader"></login-header>
    <div class="rd-main" :class="{ 'rd-account': accountMenuShow, 'fullScreen': fullScreen }" style="z-index:10;">
      <account-menu v-if="accountMenuShow" :userType="user.userType" :style="{ top: top }"></account-menu>
      <transition name="fade">
        <router-view class="rd-content" ref="view" @login="login" @updateUserAvatar="updateUserAvatar" @updateUserName="updateUserName"></router-view>
      </transition>
    </div>
    <div class="fixed">
      <div class="btn-baokaoxz">
        <div class="btn" @click="xuzhidetail()">
          <span class="text">报考须知</span>
        </div>
      </div>
      <div class="btn-baokaolc">
        <div class="btn" @click="liuchengdetail()">
          <span class="text">报考流程</span>
        </div>
      </div>
      <div class="btn-phone">
        <div class="btn">
          <span class="text">客服电话</span>
        </div>
        <div class="btn-text">
          <p class="p-text">招聘服务部</p>
          <p class="p-phone marginBottom">020-83573529</p>
          <p class="p-text">政企服务部</p>
          <p class="p-phone marginBottom">020-86388001-8013</p>
          <p class="p-text">教育培训部</p>
          <p class="p-phone marginBottom">020-86388001-8025</p>
          <p class="p-text ">注册问题咨询</p>
          <p class="p-phone marginBottom">15322386836</p>
          <!-- <div @click="goto('http://wpa.qq.com/msgrd?v=3&uin=2355878076')">技术支持</div> -->
          <!-- <div @click="goto('http://wpa.qq.com/msgrd?v=3&uin=2355878080')">技术支持2</div> -->
        </div>
      </div>
      <div class="btn-qq">
        <div class="btn">
          <span class="text">客服QQ</span>
        </div>
        <div class="btn-text">
          <div class="btn-flex marginBottom" @click="goto('http://wpa.qq.com/msgrd?v=3&uin=985437617')">
            <img :src="icoqqs2" alt="">QQ客服1
          </div>
          <div class="btn-flex" @click="goto('http://wpa.qq.com/msgrd?v=3&uin=309345056')">
            <img :src="icoqqn2" alt="">QQ客服2
          </div>
        </div>
      </div>
      <div class="btn-wechat">
        <div class="btn">
          <span class="text">微信公众号</span>
        </div>
        <div class="btn-text">
          <div class="img">
            <img :src="wechat" alt="">
          </div>
        </div>
      </div>
      <el-backtop target=".rd-page" :right="15" :bottom="10">
        <div v-show="backTopShow" class="backTop" title="回到顶部">
          <span class="text">回到顶部</span>
        </div>
      </el-backtop>
    </div>
    <rd-footer v-show="!loginHeader && !noHeaderFooter" class="rd-footer"></rd-footer>
    <login-footer v-show="loginHeader"></login-footer>
    <div class="mote" v-show="flagxz">
          <div class="xuzhi_box">
            <div class="img">
              <img :src="notice" alt="" style="width:700px; height:140px;">
            </div>
            <div class="xuzhi_txt">
              <p>1. 报名要求以“实名制”账号进行报考，即在报考系统中的账号需事先完成“实名认证”，并在“账户中心-我的简历”处完善个人信息，否则无法通过报考审核。</p>
              <p>2. 考生报名时应如实填写资料，上传本人近期正面免冠电子证件照片（jpg格式，100kb以下），所填资料与事实不符的，责任由考生自负。</p>
              <p>3. 为避免报名人员过度集中，导致网络繁忙堵塞等情况影响报名，敬请各位考生尽早在报名结束日期前进行网上报名。</p>
              <p>4. 成功注册账号后，请妥善保管个人账号登录密码等相关信息，对他人盗用密码造成的后果，责任由考生自负。</p>
            </div>
            <div class="colses" @click="colsesxz()">我知道了</div>
          </div>
    </div>
    <div class="mote" v-show="flaglc">
      <div class="liucheng_box">
        <div>
          <h3 class="head">报考流程<span  class="colsesls" @click="colseslc()">×</span></h3>
        </div>
        <div class="liuchengtu">
          <img :src="liuchengtu" alt="" style="width:650px; height:750px; margin:5px auto;">
        </div>
        <!-- <div>我知道了</div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import rdHeader from './components/Header/Header';
  import rdFooter from './components/Footer/Footer';
  import LoginHeader from './components/LoginHeader/LoginHeader';
  import LoginFooter from './components/LoginFooter/LoginFooter';
  import AccountMenu from './components/AccountMenu/AccountMenu';
  import icoqqs2 from '@/assets/img/icon/ico_qq_s2.png';
  import icoqqn2 from '@/assets/img/icon/ico_qq_n2.png';
  import wechat from '@/assets/img/pic/pic-weixin.png';
  import xuzhi from '@/assets/img/pic/ico_xuzhi.png';
  import liuchengtu from '@/assets/img/pic/liuchengtu.png';
  import liucheng from '@/assets/img/pic/ico_liucheng.png';
  import baokaoliucheng from '@/assets/img/pic/pic_baokaoliucheng.png';
  import notice from '@/assets/img/pic/pic_notice.png';

  export default {
    data() {
      return {
        icoqqs2,
        icoqqn2,
        wechat,
        xuzhi,
        liucheng,
        baokaoliucheng,
        liuchengtu,
        notice,
        clientHeight: 0,
        user: this.$store.state.user,
        top: 'auto',
        flagxz: false,
        flaglc: false
      };
    },
    components: { rdHeader, rdFooter, LoginHeader, LoginFooter, AccountMenu },
    computed: {
      // 是否是首页、招聘列表页面
      fullScreen() {
        return this.$route.meta.fullScreen;
      },
      // 是否是登录注册页面，显示登录注册专用头尾
      loginHeader() {
        return this.$route.meta.loginHeader;
      },
      // 是否是账户中心下的页面
      accountMenuShow() {
        return this.$route.meta.accountMenu;
      },
      // 是否不显示头部和尾部
      noHeaderFooter() {
        return this.$route.meta.noHeaderFooter;
      },
      backTopShow() {
        return this.$route.meta.backTopShow;
      }
    },
    mounted() {
      this.$el.addEventListener('scroll', this.scroll);
    },
    beforeDestroy() {
      this.$el.removeEventListener('scroll', this.scroll);
    },
    methods: {
      xuzhidetail() {
        this.flagxz = true;
      },
      colsesxz() {
        this.flagxz = false;
      },
      liuchengdetail() {
        this.flaglc = true;
      },
      colseslc() {
        this.flaglc = false;
      },
      scroll(e) {
        if (e.target.scrollTop >= 110) {
          this.top = '20px';
        } else {
          this.top = 'auto';
        }
      },
      goto(url) {
        window.open(url);
      },
      cityChange() {
        this.$refs.view.cityChange();
      },
      login(user) {
        this.user = user;
      },
      // 更新用户信息头像
      updateUserAvatar(avatar) {
        const user = JSON.parse(JSON.stringify(this.user));
        user.avatar = avatar;
        this.user = user;
        this.$store.dispatch('login', user);
      },
      // 更新用户信息姓名
      updateUserName(name) {
        const user = JSON.parse(JSON.stringify(this.user));
        user.name = name;
        this.user = user;
        this.$store.dispatch('login', user);
      }
    }
  };
</script>

<style lang="sass" rel="stylesheet/sass">
  @import "/assets/css/app.sass"
  @import "App.sass"
</style>
<style scoped>
.fixed{
  z-index: 9999999998;
}
.mote{
  min-width: 1180px;
  min-height: 900px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999999999;
  /* overflow: auto; */
}
.liucheng_box{
  width: 700px;
  height: 800px;
  background: #FFFFFF;
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.head{
  padding: 5px 20px;
  box-shadow: #e2e2e2 0 1px 1px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.colsesls{
  float: right;
  color: #b1afaf;
  font-size: 18px;
  cursor: pointer;
}
.xuzhi_box{
  width: 700px;
  height: 570px;
  background: #FFFFFF;
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.xuzhi_txt{
  width: 630px;
  height: 250px;
  margin: 20px auto;
}
.xuzhi_txt p{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 25px;
  margin: 20px 0;
}
.colses{
  width: 136px;
  height: 42px;
  background: linear-gradient(90deg, #C59A40, #EBC97F);
  border-radius: 2px;
  margin: 50px auto;
  color: #fff;
  font-size: 16px;
  text-align: center;
  padding-top: 10px;
  cursor: pointer;
}
.over{
  overflow-y: hidden;
}
.liuchengtu{
  width: 700px;
  height: 700px;
  text-align: center;
  /* overflow-y: auto; */
}
/* .liuchengtu::-webkit-scrollbar{
  width: 5px;
}
.liuchengtu::-webkit-scrollbar-track{
  border-radius: 3px;
}
.liuchengtu::-webkit-scrollbar-thumb{
  border-radius: 7px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #E8E8E8;
} */
</style>
